import Button from "../../Misc/Button";
import { useAppContext } from "../../../_context";
import { getLinkToContentfulMedia } from "../../../utilities/Helpers";
import Col from "react-bootstrap/Col";

const RoleCard = ({ role, last = false }) => {
  const [{ tx }] = useAppContext();
  const btnLink = role.destination || getLinkToContentfulMedia(role, "pdf");
  const opts = role.destination ? {} : { download: "download" };

  return (
    <div
      className={`border-top border-grey-white-bg py-5 d-flex flex-wrap justify-content-between ${
        last ? "border-bottom" : ""
      }`.trim()}>
      <Col lg={6} xl={7}>
        <h4>{role.jobTitle}</h4>
        <p className="mb-0 text-grey-1">{role.shortDescription}</p>
      </Col>
      <Col
        lg={6}
        xl={5}
        className="d-flex align-items-center pt-3 pt-lg-0 justify-content-end">
        <Button href={btnLink} target="_blank" {...opts}>
          {tx["Apply now"]}
        </Button>
      </Col>
    </div>
  );
};

export default RoleCard;
